import { DocumentType, Job } from 'models/jobs'
import { sanitizeNonNullableFieldsOnLoad, stripOffsetsFromStopDateTimes } from './utils'

export const formatTripRate = (tripRate: number): string => {
  return Number(tripRate).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}

export function cleanJobFormValues(values: any) {
  values = stripOffsetsFromStopDateTimes(values, false)
  values = sanitizeNonNullableFieldsOnLoad(values, false)
  values.equipment = typeof values.equipment === 'string' ? [values.equipment] : values.equipment
  values.truck_weight_lb = values.truck_weight_lb ? parseInt(values.truck_weight_lb) : null
  values.truck_length_ft = values.truck_length_ft ? parseInt(values.truck_length_ft) : null
  for (let [index, stop] of values.stops.entries()) {
    stop.truck_weight_lb = stop.truck_weight_lb ? parseInt(stop.truck_weight_lb) : null
    stop.sequence_number = index + 1
  }
  return values
}

export const jobHasUploadedRateCon = (job: Job): boolean => {
  return job.documents?.some((document) => document.type === DocumentType.RATE_CONFIRMATION) ?? false
}
